import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPixelPageView } from "../utils/metaPixel";

export const useMetaPixelPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackPixelPageView();
  }, [location.pathname, location.search]);
};
